import { debounce } from '../../02-tools'

let el
let mobileContainer
let mobileButton
let searchButton
let searchPopup
let closeSearchButton
let searchInput
let searchResultsText
let searchResults
let searchLoader

let navItems

export function Header(context = document) {
    el = context.querySelector('.js-nav')
    if (!el) {
        return
    }

    mobileContainer = el.querySelector('.js-nav-mobile-container')
    mobileButton = el.querySelector('.js-nav-mobile-button')
    searchButton = el.querySelector('.js-nav-search-button')
    searchPopup = el.querySelector('.js-nav-search')
    closeSearchButton = el.querySelector('.js-nav-search-close-button')
    searchInput = searchPopup.querySelector('input#search')
    searchResultsText = searchPopup.querySelector('.js-nav-search-result-text')
    searchResults = searchPopup.querySelector('.js-nav-search-results')
    searchLoader = searchPopup.querySelector('.js-nav-search-loader')

    mobileButton.addEventListener('click', toggleMobileMenu)
    el.addEventListener('click', (evt) => {
        toggleMenuItemDropdown(evt)

        if (evt.target.classList.contains('js-search-input-btn')) {
            clearSearch()
        }
    })

    searchResults.addEventListener('click', (evt) => {
        closeSearch(evt, true)
    })

    searchButton.addEventListener('click', () => {
        searchPopup.showModal()
        document.body.dataset.lock = true
        closeMobileMenu()
    })

    closeSearchButton.addEventListener('click', (evt) => {
        closeSearch(evt)
    })

    navItems = Array.from(el.querySelectorAll('.js-nav-item')).map((el, index) => {
        el.dataset.index = index
        const children = el.querySelector('.js-nav-children')

        return {
            el,
            children,
            isOpen: false,
            animationFrame: false
        }
    })

    searchInput.addEventListener(
        'input',
        debounce((evt) => {
            onSearchChange(evt)
        }, 300)
    )
}

function closeSearch(evt, ifEmpty = false) {
    if (ifEmpty && searchInput.value) {
        return
    }

    evt.preventDefault()
    searchPopup.close()
    document.body.removeAttribute('data-lock')
}

function onSearchChange(evt) {
    const searchTerm = evt.target.value.trim()

    if (!searchTerm.length) {
        clearSearch()
        return
    }

    getSearchResults(searchTerm)
}

function clearSearch() {
    searchLoader.classList.remove('is-active')
    searchResults.innerHTML = ''
    searchResultsText.innerHTML = ''
    searchInput.setAttribute('aria-expanded', 'false')
}

function getSearchResults(searchTerm) {
    searchLoader.classList.add('is-active')

    fetch(
        `/search/suggest?q=${searchTerm}&resources[type]=product,article&resources[limit]=8&section_id=predictive-search`
    )
        .then((response) => {
            if (!response.ok) {
                throw new Error(response.status)
            }

            return response.text()
        })
        .then((text) => {
            searchLoader.classList.remove('is-active')
            const resultMarkup = new DOMParser().parseFromString(text, 'text/html')
            const results = resultMarkup.querySelector('.js-results')
            const resultsText = resultMarkup.querySelector('.js-results-text')
            searchResults.innerHTML = results.innerHTML
            searchResultsText.innerHTML = resultsText.innerHTML
            searchInput.setAttribute('aria-expanded', 'true')
        })
        .catch((error) => {
            clearSearch()
            console.error(error)
        })
}

function toggleMobileMenu() {
    if (mobileContainer.dataset.active) {
        closeMobileMenu()
    } else {
        openMobileMenu()
    }
}

function openMobileMenu() {
    el.scrollIntoView({
        behavior: 'smooth'
    })
    mobileContainer.dataset.active = true
    mobileButton.dataset.active = true
    document.body.dataset.lock = true
}

function closeMobileMenu() {
    document.body.removeAttribute('data-lock')
    mobileContainer.removeAttribute('data-active')
    mobileButton.removeAttribute('data-active')
}

function toggleMenuItemDropdown(evt) {
    if (
        !(
            evt.target.classList.contains('js-nav-button') ||
            evt.target.classList.contains('js-nav-btn-btn')
        )
    ) {
        return
    }

    const index = evt.target.closest('.js-nav-item').dataset.index
    const navItem = navItems[index]

    if (navItem.el.dataset.active) {
        closeDropdown(navItem)
    } else {
        openDropdown(navItem)
        closeOtherDropdowns(index)
    }
}

function openDropdown(navItem) {
    navItem.el.dataset.active = true
    navItem.isOpen = true
}

function closeDropdown(navItem) {
    navItem.el.removeAttribute('data-active')
    navItem.isOpen = false
    navItem.el.querySelector('.js-nav-button').focus()
}

function closeOtherDropdowns(index) {
    navItems.forEach((el, navIndex) => {
        if (navIndex == index) {
            return
        }

        if (el.el.dataset.active) {
            closeDropdown(el)
        }
    })
}
